import { render, staticRenderFns } from "./CommentMod.vue?vue&type=template&id=5edd8af8&scoped=true&lang=html&"
import script from "./CommentMod.vue?vue&type=script&lang=js&"
export * from "./CommentMod.vue?vue&type=script&lang=js&"
import style0 from "./CommentMod.vue?vue&type=style&index=0&id=5edd8af8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd8af8",
  null
  
)

export default component.exports